import {
  ADD_BASKET_ITEM,
  MAXIMUM_ITEMS_COUNT,
  SET_COMMON_LOADING,
  SET_BASKET_DATA,
} from './constants';

/**
 * initial data is matching moscow
 * for when we don't get a new one from backend
 */
const initialState = {
  url: '/shop/basket',
  contentCookieName: 'beeline.shop.basket.fix_98140',
  contentCookiePath: '/',
  maxQuantity: MAXIMUM_ITEMS_COUNT,
  rnd: null, // required to recalculate value of selectors on cookie change
  loading: false,
  basketData: [],
  isBasketDataFetched: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_BASKET_ITEM:
      return { ...state, rnd: action.rnd };
    case SET_BASKET_DATA:
      return { ...state, basketData: action.payload, isBasketDataFetched: true };
    case SET_COMMON_LOADING:
      return { ...state, loading: action.payload };
    default:
      return state;
  }
}
